import { type Jast, type Clause, CLAUSE_TYPE_COMPOUND } from '@atlaskit/jql-ast';
import { substring } from './common.tsx';
import { getClausePosition } from './get-clause-position.tsx';

const removeFieldClauseFromJql = (ast: Jast, clauseToRemove: Clause): string => {
	const jqlString = ast.represents;
	let previousClause;
	let nextClause;
	const where = ast.query?.where;
	if (where && where.clauseType === CLAUSE_TYPE_COMPOUND) {
		for (let index = 0; index < where.clauses.length; index += 1) {
			const clause = where.clauses[index];
			const clausePosition = clause.position;
			const clauseToRemovePosition = clauseToRemove.position;
			// Early exit if position data is unavailable for our clause
			if (!clausePosition || !clauseToRemovePosition) {
				return jqlString;
			}
			if (
				clausePosition[0] === clauseToRemovePosition[0] &&
				clausePosition[1] === clauseToRemovePosition[1]
			) {
				previousClause = where.clauses[index - 1];
				nextClause = where.clauses[index + 1];
			}
		}
	}

	const clauseToRemovePosition = getClausePosition(jqlString, clauseToRemove);

	// Early exit if position data is unavailable for our clause
	if (!clauseToRemovePosition) {
		return jqlString;
	}

	const [clauseToRemoveStart, clauseToRemoveEnd] = clauseToRemovePosition;

	if (previousClause) {
		// preserve AND inbetween
		if (nextClause) {
			const nextClausePosition = getClausePosition(jqlString, nextClause);
			// Early exit if position data is unavailable for our clause
			if (!nextClausePosition) {
				return jqlString;
			}
			return (
				substring(jqlString, 0, clauseToRemoveStart) + substring(jqlString, nextClausePosition[0])
			);
		}

		const previousClausePosition = getClausePosition(jqlString, previousClause);
		// Early exit if position data is unavailable for our clause
		if (!previousClausePosition) {
			return jqlString;
		}
		return (
			substring(jqlString, 0, previousClausePosition[1]) + substring(jqlString, clauseToRemoveEnd)
		);
	}

	if (!previousClause) {
		if (nextClause) {
			const nextClausePosition = getClausePosition(jqlString, nextClause);
			// Early exit if position data is unavailable for our clause
			if (!nextClausePosition) {
				return jqlString;
			}
			return (
				substring(jqlString, 0, clauseToRemoveStart) + substring(jqlString, nextClausePosition[0])
			);
		}
		return substring(jqlString, 0, clauseToRemoveStart) + substring(jqlString, clauseToRemoveEnd);
	}

	return jqlString;
};

export default removeFieldClauseFromJql;
